const AUTH_LOGIN = '/auth/login'
const HOME = '/'

const CREATE = '/create'
const UPDATE = '/update'
const OVERVIEW = '/overview'
const HISTORY = '/history'
const ORDER = '/order'
const IMPORT = '/import'
const EXPORT = '/export'
const REQUEST = '/request'
const CONNECT = '/connect'
const DETAIL = '/detail'
const DETAIL_TRANSACTION = '/detail-transaction'
const DETAIL_PACKAGE = '/detail-package'
const ACCOUNTS = '/accounts'

const PROFILE = '/profile'
const COMPANY = '/company'
const PACKAGE = '/package'
const TRANSACTION = '/transaction'
const TELEGRAM = '/telegram'
const USER = '/user'
const ROLE = '/role'
const DAU_NOI = '/dau-noi'
const GIA_HAN = '/gia-han'
const SIM_PASSPORT = '/sim-passport'
const TOP_UP = '/top-up'
const PACKAGE_API = '/api-package'
const REGISTER_ADDON = '/register-addon'
const KIT_SIM = '/kit-sim'
const KIT_ORDER = '/kit-order'
const EXTENSION = '/extension'
const CUSTOMER = '/customer'
const AGENCY = '/agency'
const KPI = '/kpi'
const TELESALE = '/telesale'
const TELESALE_CALLING = '/telesale-calling'
const DASHBOARD = '/dashboard'
const USER_PARTNER = '/user-partner'
const CONFIG = '/config'
const ADMIN = '/admin'
const INVOICE = '/invoice'
const ZALO_ACCOUNT = '/zalo-account'
const PERMISSIONS = '/permissions'
const ZALO_CONFIG = '/zalo-config'

export {
  AUTH_LOGIN,
  PROFILE,
  HOME,
  CREATE,
  UPDATE,
  OVERVIEW,
  HISTORY,
  ORDER,
  IMPORT,
  EXPORT,
  REQUEST,
  CONNECT,
  DETAIL,
  DETAIL_TRANSACTION,
  DETAIL_PACKAGE,
  COMPANY,
  PACKAGE,
  TRANSACTION,
  TELEGRAM,
  USER,
  ROLE,
  DAU_NOI,
  GIA_HAN,
  SIM_PASSPORT,
  TOP_UP,
  PACKAGE_API,
  REGISTER_ADDON,
  KIT_SIM,
  KIT_ORDER,
  EXTENSION,
  CUSTOMER,
  AGENCY,
  KPI,
  TELESALE,
  TELESALE_CALLING,
  DASHBOARD,
  USER_PARTNER,
  CONFIG,
  ADMIN,
  INVOICE,
  ZALO_ACCOUNT,
  ACCOUNTS,
  PERMISSIONS,
  ZALO_CONFIG,
}
